import React, { useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import _ from 'lodash'

// Components
import { EventHeader } from '../../components/EventHeader'
import { StateContainer } from '../../components/StateContainer'
import SyncConfiguration from './SyncConfiguration'

// Stores
import { NavigationStoreContext } from '../../stores/NavigationStore'

// Services
import { getOrganizationApiOptions } from '../../services/organizations.service'

// Utils
import { joinClassNames } from '../../utils/helpers'

const TABS = [
  {
    id: 0,
    label: 'Primary Sync',
  },
  {
    id: 1,
    label: 'Secondary Sync',
  },
]

/**
 *
 * EventApiConfig
 *
 */
const EventApiConfig = observer(() => {
  // Context
  const { event, organizationId } = useContext(NavigationStoreContext)

  // State
  const [active, setActive] = useState(TABS[0])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [registrationOptions, setRegistrationOptions] = useState([])

  useEffect(() => {
    const getOptions = async () => {
      const response = await getOrganizationApiOptions(organizationId, setError, setLoading)
      if (response) {
        const options = _.map(response, (item) => ({
          label: item.system,
          id: item.system,
          type: item.authType,
          enabledFor: item.enabledFor,
        }))

        setRegistrationOptions(options)
      }
    }

    getOptions()
  }, [])

  return (
    <div className="h-full w-full">
      <StateContainer loading={loading} error={error}>
        <div className="relative flex h-full w-full flex-col space-y-3 overflow-y-auto p-3">
          <div className="flex flex-row place-items-center justify-between">
            <EventHeader event={event} />
          </div>

          <span className="text-md font-bold">API Config</span>

          <div className="h-full w-full">
            {event?.enableSecondaryRegistrationSync && (
              <div className="px-3">
                <nav className="flex" aria-label="Tabs">
                  {TABS.map((tab) => {
                    const activeTab = active.id === tab.id

                    return (
                      <button
                        type="button"
                        key={tab.label}
                        onClick={() => setActive(tab)}
                        className={joinClassNames(
                          activeTab
                            ? 'border-purple-700 bg-[#8c56f626] text-purple-700'
                            : 'border-b-transparent text-gray-600 hover:border-purple-700 hover:bg-[#8c56f626] hover:text-purple-700',
                          'group relative flex w-1/2 items-center justify-center rounded-t-[10px] border-b-2 px-4 py-2 text-sm font-medium',
                        )}
                        aria-current={activeTab ? 'page' : undefined}
                      >
                        {tab.label}
                      </button>
                    )
                  })}
                </nav>
              </div>
            )}

            <div className="shadow-xm flex w-full flex-col rounded-[15px] bg-white px-5 py-4">
              {active.id === 0 && (
                <SyncConfiguration
                  registrationOptions={_.filter(registrationOptions, (item) =>
                    item.enabledFor.includes('primary'),
                  )}
                />
              )}
              {active.id === 1 && (
                <SyncConfiguration
                  secondary
                  registrationOptions={_.filter(registrationOptions, (item) =>
                    item.enabledFor.includes('secondary'),
                  )}
                />
              )}
            </div>
          </div>
        </div>
      </StateContainer>
    </div>
  )
})

export default EventApiConfig
